import { Tools } from "../../../utilities/Tools";

class DragAndDropFiles {
    constructor(input, settings = {}) {
        this.settings = Object.assign(
            {},
            Tools.parseStringValuesInObjectLiteral(
                (({ dataset }) => {
                    const datasetObject = Object.assign({}, dataset);

                    delete datasetObject.toggle;
                    return datasetObject;
                })(input)
            ),
            Tools.parseStringValuesInObjectLiteral(settings)
        );
        this.input = input;
        this._dropZone = null;
        this.dragBind = this.dragHandler.bind(this);
        this.dragendBind = this.dragendHandler.bind(this);
        this.dragenterBind = this.dragenterHandler.bind(this);
        this.dragleaveBind = this.dragleaveHandler.bind(this);
        this.dragoverBind = this.dragoverHandler.bind(this);
        this.dragstartBind = this.dragstartHandler.bind(this);
        this.dropBind = this.dropHandler.bind(this);
        this.droppedFiles = new Map();
        this.formData = new FormData(this.input.form);

        // Inicjalizacja
        this.init();
    }

    get dropZone() {
        return this._dropZone;
    }

    set dropZone(value) {
        this._dropZone = value;
    }

    events() {
        //
        this.dropZone.addEventListener("drag", this.dragBind);

        //
        this.dropZone.addEventListener("dragend", this.dragendBind);

        //
        this.dropZone.addEventListener("dragenter", this.dragenterBind);

        //
        this.dropZone.addEventListener("dragleave", this.dragleaveBind);

        //
        this.dropZone.addEventListener("dragover", this.dragoverBind);

        //
        this.dropZone.addEventListener("dragstart", this.dragstartBind);

        //
        this.dropZone.addEventListener("drop", this.dropBind);

        //
        this.input.addEventListener("change", (event) => {
            this.addDroppedFiles(event);
        });
    }

    eventsDropZone() {
        this.dropZone.querySelectorAll(".btn-close").forEach((btn) => {
            btn.addEventListener("click", (event) => {
                this.removeDroppedFiles(event.target.dataset.fileName);
            });
        });
    }

    eventsControls() {
        this.input.nextElementSibling.querySelector(".drag-and-drop-files__remove-all").addEventListener("click", () => {
            this.removeDroppedFiles("all");
        });
    }

    dragHandler(event) {
        //console.log(event);
    }

    dragendHandler(event) {
        //console.log(event);
    }

    dragenterHandler(event) {
        event.preventDefault();

        this.dropZone.classList.add("drag-and-drop-files__drop-zone--dragenter");
    }

    dragleaveHandler(event) {
        event.preventDefault();

        this.dropZone.classList.remove("drag-and-drop-files__drop-zone--dragenter");
    }

    dragoverHandler(event) {
        // Zapobiegaj otwieraniu pliku w przeglądarce.
        event.preventDefault();
    }

    dragstartHandler(event) {
        //console.log(event);
    }

    dropHandler(event) {
        // Zapobiegaj otwieraniu pliku w przeglądarce.
        event.preventDefault();

        //
        this.addDroppedFiles(event);

        //
        this.dropZone.classList.remove("drag-and-drop-files__drop-zone--dragenter");
    }

    addDroppedFiles(event) {
        // Utworzenie DataTransfer.
        const dataTransfer = new DataTransfer();

        switch (event.type) {
            case "drop":
                // Użyj interfejsu DataTransferItemList, aby uzyskać dostęp do plików.
                if (event.dataTransfer.items) {
                    let itemsLength = event.dataTransfer.items.length;

                    for (let i = 0; i < itemsLength; i++) {
                        // Jeśli upuszczone elementy nie są plikami, to są odrzucane.
                        if (event.dataTransfer.items[i].kind === "file") {
                            const file = event.dataTransfer.items[i].getAsFile();

                            if (!this.droppedFiles.has(file.name)) {
                                if (!this.checkDroppedFileSizeLimit(file.size)) {
                                    this.showSizeLimitAlert(file);
                                } else {
                                    this.droppedFiles.set(file.name, file);
                                }
                            }
                        }
                    }
                }

                break;

            case "change":
                let filesLength = event.target.files.length;

                for (let i = 0; i < filesLength; i++) {
                    const file = event.target.files[i];

                    if (!this.droppedFiles.has(file.name)) {
                        if (!this.checkDroppedFileSizeLimit(file.size)) {
                            this.showSizeLimitAlert(file);
                        } else {
                            this.droppedFiles.set(file.name, file);
                        }
                    }
                }

                break;

            default:
                break;
        }

        this.droppedFiles.forEach((file) => {
            dataTransfer.items.add(file);
        });

        // Dodanie plików do pola input.
        this.input.files = dataTransfer.files;

        //
        this.renderFilesList();
    }

    removeDroppedFiles(key) {
        let files = null;

        if (key === "all") {
            this.droppedFiles.clear();
        } else {
            // Utworzenie DataTransfer.
            const dataTransfer = new DataTransfer();

            this.droppedFiles.delete(key);

            this.droppedFiles.forEach((file) => {
                dataTransfer.items.add(file);
            });

            files = dataTransfer.files;
        }

        // Dodanie plików do pola input.
        this.input.files = files;

        //
        this.renderFilesList();
    }

    checkDroppedFileSizeLimit(size) {
        return size <= parseInt(this.input.dataset.sizeLimit);
    }

    showSizeLimitAlert(file) {
        this.input.nextElementSibling.insertAdjacentHTML(
            "afterbegin",
            `<div class="alert alert-warning alert-dismissible fade show" role="alert">
                    Plik ${file.name} <strong>(${Tools.formatSizeUnits(file.size)})</strong> jest za duży! Limit: <strong>${Tools.formatSizeUnits(
                parseInt(this.input.dataset.sizeLimit)
            )}</strong> 
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>`
        );
    }

    renderFilesList() {
        let html = "";

        //
        if (this.droppedFiles.size > 0) {
            this.dropZone.classList.add("drag-and-drop-files__drop-zone--file");
        } else {
            this.dropZone.classList.remove("drag-and-drop-files__drop-zone--file");
        }

        //
        this.droppedFiles.forEach((droppedFile) => {
            html += `
                    <li class="drag-and-drop-files__drop-zone__item">
                        <span class="fiv-sqo fiv-icon-${droppedFile.name.split(".").reverse()[0]}"></span>
                        ${droppedFile.name} (rozmiar: ${Tools.formatSizeUnits(droppedFile.size)})
                        <button type="button" class="btn-close" aria-label="Usuń plik" title="Usuń plik" data-file-name="${droppedFile.name}"></button>
                    </li>`;
        });

        //
        this.dropZone.innerHTML = html;

        // eventsDropZone
        this.eventsDropZone();

        // Renderowanie .drag-and-drop-files__controls
        this.renderControls();
    }

    renderControls() {
        let html = `
                    <label class="btn btn-sm text-secondary drag-and-drop-files__attach" title="Załącz pliki z komputera" for="${
                        this.input.id
                    }"><i class="fas fa-paperclip"></i></label>
                    <button class="btn btn-sm text-secondary drag-and-drop-files__remove-all ${
                        this.droppedFiles.size === 0 ? "disabled" : ""
                    }" title="Usuń wszystkie pliki" type="button"><i class="fas fa-trash"></i></button>`;

        this.input.nextElementSibling.querySelector(".drag-and-drop-files__controls").innerHTML = html;

        //
        this.eventsControls();
    }

    render() {
        let html = `
                    <div class="drag-and-drop-files">
                        <ul class="drag-and-drop-files__drop-zone" data-text="Przeciągnij jeden lub więcej plików do strefy upuszczania..."></ul>
                        <div class="drag-and-drop-files__controls"></div>
                    </div>`;

        // Ukrycie pola input
        this.input.classList.add("d-none");

        // Wyświetlenie pola drag and drop.
        this.input.parentElement.insertAdjacentHTML("beforeend", html);

        // Renderowanie .drag-and-drop-files__controls
        this.renderControls();

        //
        this.dropZone = this.input.nextElementSibling.querySelector(".drag-and-drop-files__drop-zone");

        // Ustawienie zdarzeń.
        this.events();
    }

    init() {
        // Utworzenie Map.
        iksoris.instances = iksoris.instances || new Map();

        if (!Boolean(iksoris.instances.get(this.input.id))) {
            iksoris.instances.set(this.input.id, this);
        }

        // Renderowanie
        this.render();
    }
}

export { DragAndDropFiles };
